import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { loginUser, dismissMessage } from "../../reduxStore/actions/auth";
import { getConstants } from "../../reduxStore/actions/serverConstants";

import PublicLayout from "../../containers/Layout/PublicLayout";
import LoginForm from "../../containers/LoginForm";
import Loader from "../../components/loader";
import LogoImg from "../../assets/images/group-3@3x.png";

class LoginPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }

  componentDidMount() {
    //get the constants from the server
    this.props.getConstants();
  }

  componentWillUnmount() {
    if (this.timeoutIsLoading) clearTimeout(this.timeoutIsLoading);
  }

  onLoginFormSubmit = async formValues => {
    this.setState({
      isLoading: true
    });

    // login user
    await this.props.loginUser({
      userName: formValues.userName,
      password: formValues.password
    });

    this.setState({
      isLoading: false
    });

    if (this.props.auth.error) {
      setTimeout(() => {
        this.props.dismissMessage();
      }, 3000);
    }
  };
  render() {
    return (
      <PublicLayout>
        {this.state.isLoading && <Loader />}
        <div className={this.state.isLoading ? "disableContainer" : ""}>
          <div className="login-page-container container d-flex align-items-center justify-content-center">
            <div className="lg-page-inner-container">
              <div className="lp-header row">
                <div className="col-md-12">Login</div>
              </div>
              <div className="row lp-content-container d-flex justify-content-center align-items-center">
                <div className="col-md-12 logo-img-container d-flex justify-content-center align-items-center">
                  <img src={LogoImg} alt="logo-img" />
                </div>
                <div className="col-md-12 d-flex justify-content-center align-items-center lg-form-container">
                  <LoginForm
                    onFormSubmit={this.onLoginFormSubmit}
                    serverErrorMsg={this.props.auth.message}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </PublicLayout>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  loginUser: data => dispatch(loginUser(data)),
  dismissMessage: () => dispatch(dismissMessage()),
  getConstants: () => dispatch(getConstants())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
